import { FC, useEffect } from "react";

import { EmailLetterFilled, HelpDeskColored } from "@livechat/design-system-icons";
import { DesignToken, Icon, SpacingToken } from "@livechat/design-system-react-components";

import imageSrc from "assets/img/welcome/manage-emails.png";
import Text from "components/layout/Text";
import { EventPlace, trackEngagement } from "helpers/analytics";
import { withVar } from "themes/helpers";

import { WelcomeTutorialRoutes } from "../helpers";

import TitleOnboardingStep from "./TitleOnboardingStep";

const ManageEmailsStep: FC = () => {
  useEffect(() => {
    trackEngagement("LC integration: Welcome screens", EventPlace.Onboarding, {
      step: 1,
    });
  }, []);

  return (
    <TitleOnboardingStep
      currentStep={1}
      title={
        <Text
          // TODO: replace with Heading component when DS adds new size
          fontWeight="600"
          fontSize="40px"
          lineHeight="54px"
          color={withVar(DesignToken.ContentBasicPrimary)}
          marginV={withVar(SpacingToken.Spacing4)}
        >
          Manage all emails <br /> from customers in HelpDesk
        </Text>
      }
      subtitle="Forward a copy of the messages from your current inboxes to HelpDesk. Create one email hub."
      imageSource={imageSrc}
      firstIcon={<Icon source={HelpDeskColored} />}
      secondIcon={<Icon source={EmailLetterFilled} customColor={withVar(DesignToken.ContentBasicPrimary)} />}
      nextButtonRouteLink={WelcomeTutorialRoutes.LC_TICKET_FORM}
      backButtonDisabled
    />
  );
};

export default ManageEmailsStep;
